import React, { ReactElement } from 'react';
import {
  IntegrationHubApp,
  IntegrationHubAppProps,
  ProductEnum,
} from '@integrations/integration-hub';
import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Page, PageBody, PageHeader } from '../../libs/shared/page';
import { QlfPageErrorBoundary } from '../../libs/shared/QlfPageErrorBoundary';
import { TopBar } from '../../libs/shared/layout/TopBar';
import { useAccounts } from '../../libs/accounts/AccountsContext';
import { useConfiguration } from '../../libs/ConfigurationContext';

const useStyles = makeStyles<Theme>(({ spacing }) =>
  createStyles({
    body: {
      display: 'flex',
      '& > div': {
        padding: spacing(2),
      },
      '& > div, & > div > div': {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      },
      '& .SplitPane': {
        flexGrow: 1,
      },
    },
  }),
);

export function IntegrationsIndexPage(): ReactElement {
  const classes = useStyles();
  const { currentAccount } = useAccounts();
  const { i18n } = useTranslation();
  const { elasticApmEnvironment, elasticApmServerUrl } = useConfiguration();

  const config: IntegrationHubAppProps['config'] = {
    lang: i18n.language,
    auth: {
      token: undefined,
    },
    product: ProductEnum.LOYALTY,
    page: 'LIST_INTEGRATIONS',
    tenantId: currentAccount.id,
    environment: elasticApmEnvironment,
    elasticApmServerUrl,
    elasticApmServiceName: 'gamification-frontend',
    elasticApmActive: true,
  };

  return (
    <Page>
      <PageHeader>
        <TopBar />
      </PageHeader>
      <PageBody className={classes.body}>
        <QlfPageErrorBoundary>
          <IntegrationHubApp config={JSON.stringify(config)} lang={i18n.language} i18n={i18n} />
        </QlfPageErrorBoundary>
      </PageBody>
    </Page>
  );
}
